// JS
import React, { useState, useRef } from 'react';
import { renderHTML } from '../shared/utils';

// COMPS
import ProductShippingReturns from '../ProductShippingReturns';

// COMPONENT
const ProductInformation = ({
  data,
  isMobile,
  shippingInformation,
  returnsInformation
}) => {
  /* Uncomment the following 2 lines to set initial height for pre-expanded accrdion */
  //const [setActive, setActiveState] = useState('active');
  //const [setHeight, setHeightState] = useState('380px');
  const [setActive, setActiveState] = useState('');
  const [setHeight, setHeightState] = useState('0px');
  const content = useRef(null);

  const toggleAccordion = () => {
    setActiveState(setActive === '' ? 'active' : '');
    setHeightState(
      setActive === 'active' ? '0px' : `${content.current.scrollHeight}px`
    );
  };

  const ammendChar = (ammendChar) => {
    return ammendChar
      ?.toString()
      .replace(/\|/g, '')
      .replaceAll('•', '<li class="short_description">');
  };

  const productInformationContent = () => {
    return (
      <React.Fragment>
        <div className="product-information-content">
          <div className="product-information-title">
            <span className="product-information-brand-name">
              {data.product.attributes.brand}
            </span>
            <span className="product-information-name">
              {data.product.name}
            </span>
          </div>
          <div className="product-information-body">
            {renderHTML(ammendChar(data.product.attributes.short_description))}
            {/*{renderHTML(ammendChar(data.product.attributes.description))}*/}
          </div>
        </div>
      </React.Fragment>
    );
  };

  if (isMobile) {
    return (
      <div id="product-information-content-panel">
        {data && data.product && (
          <div className="accordion-policies">
            <div className="accordion__item">
              <div className={`accordion__content ${setActive}`}>
                <div className="accordion__heading" onClick={toggleAccordion}>
                  <div className="accordion__button">Product Information</div>
                </div>
                <div
                  ref={content}
                  style={{ maxHeight: `${setHeight}` }}
                  className={`accordion__panel`}
                >
                  {productInformationContent()}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div
        className={'product-information'}
        id="product-information-content-panel"
      >
        {data && data.product && (
          <div className="product-information-container">
            {productInformationContent()}
            <ProductShippingReturns
              data={data}
              shippingInformation={shippingInformation}
              returnsInformation={returnsInformation}
              //isMobile={isMobile}
              PSRButtonInfoSection={true}
            />
          </div>
        )}
      </div>
    );
  }
};

export default ProductInformation;
